import { TrelloStorage } from '@trello/storage';

/**
 * Tells agent-recommended boards apart from boards the member prompted
 * themselves, and carries the recommendation's category through to the
 * feedback — without splitting either out of AI Board Builder into its own
 * feedback feature.
 *
 * The marker lives in storage, keyed by board, because the collector is shown
 * on the board screen after the board builder overlay that started the
 * creation is gone — and because a member-keyed marker would outlive the board
 * it describes and mislabel the next AI board's feedback.
 */
export const getAiBoardBuilderFeedbackAttributes = (
  boardId: string,
): Record<string, string> => {
  const recommendationCategoryId = TrelloStorage.get(
    `aiBoardBuilderFromRecommendation-${boardId}`,
  );

  return recommendationCategoryId
    ? {
        aiBoardBuilderTrigger: 'agentRecommendation',
        recommendationCategoryId,
      }
    : { aiBoardBuilderTrigger: 'userPrompt' };
};
